import { useState } from 'react';
import styles from './MeetTheTeam.module.css';

// Headshots live at frontend/public/team/*.jpg. Until added, each card falls back to
// the initials avatar (so the page never shows a broken image).
const TEAM = [
  {
    initials: 'MS',
    photo: '/team/matthew-sandoval.jpg',
    name: 'Matthew Sandoval',
    role: 'Co-founder & CEO',
    bio: '7+ years of leadership in business operations and hardcore outbound sales. Built RepBuddy to create the streamlined, zero-fluff tool he always wished he had in the trenches.',
  },
  {
    initials: 'GG',
    photo: '/team/giri-gummadi.jpg',
    name: 'Giri Gummadi',
    role: 'Co-founder & Technical Advisor',
    bio: 'Over 5 years of GenAI and full-stack experience, turning experimental AI into bulletproof, enterprise-grade systems.',
  },
  {
    initials: 'SB',
    photo: '/team/saketh-bandi.jpg',
    name: 'Saketh Bandi',
    role: 'Founding Engineer',
    bio: 'Deep background in full-stack development and enterprise Generative AI, transforming complex LLM architecture into reliable workflows.',
  },
  {
    initials: 'PG',
    photo: '/team/pavani-gummadi.jpg',
    name: 'Pavani Gummadi',
    role: 'Business Analyst & Social Media Manager',
    bio: 'Computer Science graduate bridging the gap between our engineering team and our market-facing social campaigns.',
  },
];

function TeamAvatar({ photo, initials, name }) {
  const [ok, setOk] = useState(Boolean(photo));
  if (ok) {
    return (
      <img
        className={styles.photo}
        src={`${process.env.PUBLIC_URL}${photo}`}
        alt={name}
        onError={() => setOk(false)}
      />
    );
  }
  return <div className={styles.avatar} aria-hidden="true">{initials}</div>;
}

export default function MeetTheTeam() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.head}>
          <span className={styles.label}>Meet the team</span>
          <h2 className={styles.heading}>The people behind your agents.</h2>
        </div>

        <div className={styles.grid}>
          {TEAM.map((m) => (
            <article key={m.name} className={styles.card}>
              <TeamAvatar photo={m.photo} initials={m.initials} name={m.name} />
              <h3 className={styles.name}>{m.name}</h3>
              <span className={styles.role}>{m.role}</span>
              <p className={styles.bio}>{m.bio}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
